module.exports = __webpack_public_path__ + "img/feed_Gif.c7e4d1a9.svg";